import { createFeatureSelector, createSelector } from '@ngrx/store'
import { QueryState } from '../state/query.state'

const getQueryState = createFeatureSelector<QueryState>('query')

export const getQueryDashboardInfo = () => createSelector(getQueryState, (state) => state?.dashboard)

export const getQueryDetails = () =>
  createSelector(getQueryState, (state) => {
    return state?.details
  })
  export const getQuerySummaryList = () =>
    createSelector(getQueryState, state => {
      return state?.summary
    })